import React from 'react';
import { Bot, Mic, Upload } from 'lucide-react';
import { Dialog } from '../../components/ui/Dialog';
import { cn } from '../../components/ui/cn';
import { t } from '../../lib/i18n';

interface MobileRecordSheetProps {
  open: boolean;
  onClose: () => void;
  onRecord: () => void;
  onSendBot: () => void;
  onUpload: () => void;
}

/** Ortadaki kayıt düğmesinin alt sayfası: telefonla kaydet, bot gönder ya da dosya yükle. */
export const MobileRecordSheet: React.FC<MobileRecordSheetProps> = ({ open, onClose, onRecord, onSendBot, onUpload }) => {
  const option = (
    icon: React.ReactNode,
    title: string,
    hint: string,
    onClick: () => void,
    primary = false
  ) => (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'w-full min-h-[72px] flex items-center gap-3.5 px-3.5 py-3 rounded-[18px] text-left active:opacity-80',
        primary ? 'bg-brand-soft' : 'bg-secondary'
      )}
    >
      <span
        className={cn(
          'w-11 h-11 rounded-full flex items-center justify-center shrink-0',
          primary ? 'bg-brand text-on-brand' : 'bg-background text-foreground'
        )}
      >
        {icon}
      </span>
      <span className="flex flex-col gap-0.5 min-w-0">
        <span className="text-[16px] font-bold text-foreground">{title}</span>
        <span className="text-[14px] text-muted-foreground">{hint}</span>
      </span>
    </button>
  );

  return (
    <Dialog open={open} onClose={onClose} title={t('Neyi kaydedelim?', 'What should we record?')}>
      <div className="space-y-2 pb-2">
        {option(
          <Mic className="w-5 h-5" />,
          t('Bu telefonla kaydet', 'Record with this phone'),
          t('Yüz yüze görüşme ya da hoparlördeki arama', 'An in-person meeting or a call on speaker'),
          onRecord,
          true
        )}
        {option(
          <Bot className="w-5 h-5" />,
          t('Toplantıya bot gönder', 'Send a bot to a meeting'),
          t('Meet, Zoom ya da Teams bağlantısı', 'A Meet, Zoom or Teams link'),
          onSendBot
        )}
        {option(
          <Upload className="w-5 h-5" />,
          t('Ses dosyası yükle', 'Upload an audio file'),
          t('m4a, mp3, wav — ya da başka uygulamadan Paylaş', 'm4a, mp3, wav — or Share from another app'),
          onUpload
        )}
      </div>
    </Dialog>
  );
};
